var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",null,React.createElement("g",null,React.createElement("g",{"transform":"translate(-851 -2999) translate(851 2997) translate(0 2)"},[React.createElement("rect",{"width":"18","height":"18","fill":"#E5ECEE","opacity":".6","rx":"5","key":0}),React.createElement("path",{"stroke":"#ED2246","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","d":"M5.562 10L7.544 12.34 13.476 5.656","key":1})])))));
}

Checkmark.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
